import React from 'react'
// libs
import styled, { css } from 'styled-components'
// components
import Paper from 'components/UI/Paper'
import Grid from '@mui/material/Grid2'
// themes
import colors from 'themes/colors'
import ReviewIconOrigin from 'src/icons/review-blue.svg'
// utils
import { darken, size } from 'polished'

// @ts-ignore
const Wrapper = styled(({ $isFullModal, $isSidebar, ...props }) => <Paper {...props} />)<any>`
  && {
    align-items: center;
    background-color: ${colors.white100};
    border-bottom: 1px solid ${colors.gray210};
    border-radius: 35px 0 0 35px;
    display: flex;
    left: -10px;
    margin-top: 10px;
    min-height: 70px;
    padding-left: 17px;
    position: relative;
    width: 610px;
    z-index: 1;

    ${({ $isFullModal, $isSidebar }) =>
      $isFullModal &&
      css`
        border-radius: 0 35px 35px 0;
        left: 0;
        width: ${$isSidebar ? '424px' : '490px'};
      `}
  }
`

const InfoWrapper = styled((props) => <Grid {...props} />)`
  && {
    margin-left: 8px;
    width: 168px;
  }
`

const DueDateWrapper = styled.div`
  font-size: 14px;
  color: ${colors.blue500};
  margin-right: 8px;
`

const Button = styled.div<{ $isFullModal: boolean }>`
  align-items: center;
  background-color: ${colors.blue500};
  color: white;
  cursor: pointer;
  display: flex;
  flex-direction: column;
  font-weight: bold;
  height: 69px;
  justify-content: center;
  margin: 1px 1px 1px auto;
  width: 100px;
  z-index: 1;

  &:hover {
    background-color: ${darken(0.07, colors.blue500)};
  }

  ${({ $isFullModal }) => $isFullModal && ' border-radius: 0 35px 35px 0;'}
`

const ButtonLabel = styled.div`
  padding: 0 8px;
  font-size: 14px;
  text-align: center;
`

const DueIndicator = styled(({ isDueToday, ...props }) => <Grid {...props} />)`
  && {
    font-size: 13px;

    ${({ isDueToday }) => (isDueToday ? `color: ${colors.orange300}` : `color: ${colors.red300}`)}
  }
`

const ProgressIndicator = styled((props) => <Grid {...props} />)`
  && {
    font-size: 13px;
  }
`

const InProgressIndicator = styled((props) => <Grid {...props} />)`
  background-color: ${colors.blue500};
  border-radius: 35px 0 0 35px;
  color: white;
  font-weight: bold;
  height: 68px;
  justify-content: center;
  margin-left: auto;
  max-width: 25%;
  font-size: 14px;
  padding: 0 12px;
`

const AvatarWrapper = styled((props) => <Grid {...props} />)`
  && {
    width: fit-content;

    span:first-child > div {
      margin-left: 5px;
    }

    div {
      box-shadow:
        0 1px 3px 0 rgba(0, 0, 0, 0.2),
        0 1px 1px 0 rgba(0, 0, 0, 0.14),
        0 0 0 0 rgba(0, 0, 0, 0.12);
      font-size: 14px;
      height: 32px;
      width: 32px;
    }

    & > span {
      position: relative;
      margin-right: -10px;
    }
  }
`

const ReviewIcon = styled(ReviewIconOrigin)`
  && {
    margin-left: 2px;
    ${size('29px')};

    path {
      fill: ${colors.blue500};
    }
  }
`

const TextSeparator = styled('div')`
  margin: 0 3px;
  font-size: 13px;
`

export {
  AvatarWrapper,
  Button,
  ButtonLabel,
  DueDateWrapper,
  DueIndicator,
  InfoWrapper,
  InProgressIndicator,
  ProgressIndicator,
  ReviewIcon,
  TextSeparator,
  Wrapper
}
